module.exports = __webpack_public_path__ + "static/img/route.b8fb7002.svg";